import { createFileRoute } from "@tanstack/react-router";
import CanTmsBeConsideredAfterMultipleAntidepressants from "@/pages/articles/CanTmsBeConsideredAfterMultipleAntidepressants";
export const Route = createFileRoute(
  "/can-tms-be-considered-after-multiple-antidepressants",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS After Multiple Antidepressants | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "If you’ve tried two or more antidepressants without relief, TMS may help. Learn how TMS and SAINT TMS treat depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "TMS After Multiple Antidepressants | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "If you’ve tried two or more antidepressants without relief, TMS may help. Learn how TMS and SAINT TMS treat depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/can-tms-be-considered-after-multiple-antidepressants",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/can-tms-be-considered-after-multiple-antidepressants",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CanTmsBeConsideredAfterMultipleAntidepressants />;
}
